<script setup>
import { ref, computed, onMounted } from 'vue';

import AppUserAvatar from '@/components/general/UserAvatar.vue';
import AppEditProfileModal from '@/components/profile/EditProfileModal.vue';

import { handleError } from '@/services/utils';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import { useUser } from '@/composables/useUser';

const userStore = useUserStore();
const { userName } = useUser();

const selectedUser = ref(null);

const profilePopover = ref();
function openPopover($event) {
  profilePopover.value.toggle($event);
  selectedUser.value = userStore.user;
}

function logout() {
  profilePopover.value.hide();
  useAuthStore().logout();
}

const popupOpen = ref(false);
function updatePopupState(show) {
  popupOpen.value = show;
}

const showEditProfileModal = ref(false);

onMounted(async () => {
  if(!userStore.user.first_name) {
    selectedUser.value = userStore.user;
    showEditProfileModal.value = true;
  }
})

async function onUpdate() {
  showEditProfileModal.value = false;
  try {
    await userStore.fetchUser();
  } catch (error) {
    handleError(error);
  }
}
</script>
<template>
  <span
    class="inline-block flex cursor-pointer items-center gap-2"
    @click="openPopover"
  >
    <app-user-avatar :user="userStore.user" />
    <i
      class="icon-[prime--sort-down-fill] h-4 w-4 bg-surface-950 text-lg dark:bg-surface-50"
      :class="{
        'rotate-180 transform': popupOpen,
      }"
    />

    <Popover
      ref="profilePopover"
      pt:root:class="after:!hidden before:!hidden content-border-color !border"
      :ptOptions="{ mergeProps: true }"
      @show="updatePopupState(true)"
      @hide="updatePopupState(false)"
    >
      <div class="flex flex-col gap-2">
        <div class="mb-8 flex gap-2">
          <app-user-avatar
            class="!h-12 !w-12"
            :user="userStore.user"
            @click="openPopover"
          />
          <div class="">
            <div class="text-lg font-semibold">
              {{ userName(userStore.user) }}
            </div>
            <div class="text-sm text-surface-500">
              {{ userStore.user.email }}
            </div>
          </div>
        </div>
        <div>
          <Button
            label="Edit profile"
            class="w-full"
            @click="
              profilePopover.hide();
              showEditProfileModal = true;
            "
          />
        </div>
        <div>
          <Button
            class="w-full font-semibold"
            @click="logout"
            label="Log out"
            text
            severity="danger"
          >
            <i class="icon-[material-symbols--logout-rounded] text-xl" />
            Log out
          </Button>
        </div>
      </div>
    </Popover>

    <app-edit-profile-modal
      v-if="selectedUser"
      v-model:visible="showEditProfileModal"
      :selected-item="selectedUser"
      @success="onUpdate"
    />
  </span>
</template>
